import Icon from '../components/Icon.vue'

Icon.register({
  'eye-dropper': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M50.8 333.3l126.6-126.6 128 128-126.6 126.6c-12 12-28.3 18.7-45.3 18.7h-45.5l-56 32-32-32 32-56v-45.5c0-17 6.8-33.3 18.8-45.3zM483.9 28.1c37.5 37.5 37.5 98.3 0 135.8l-77.1 77.1 13.1 13.1c9.4 9.4 9.4 24.6 0 33.9l-41 41c-9.3 9.3-24.5 9.4-33.9 0l-161.9-161.9c-9.4-9.4-9.4-24.6 0-33.9l41-41c9.3-9.3 24.5-9.4 33.9 0l13.1 13.1 77.1-77.1c37.5-37.5 98.3-37.5 135.8 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/eye-dropper.js
// module id = 1313
// module chunks = 0